// Master JS for Site V3 header

/* global performBannerAction */

import autosize from "autosize";

import { UserAvatar } from "./webcomponents/user-avatar.js";
import { WireupExpanders, WireupRevealers, WireupMobileMenu } from "./lib/data-expanders.js";

// Sync CookieYes optouts with server
document.addEventListener("cookieyes_consent_update", async function (eventData) {
    const data = eventData.detail;
    if (data.rejected.includes("advertisement")) {
        // If the user is already opted out, ignore. CookieYes fires the event every load if GPC is on.
        if (!window.UserDoNotSellShare) {
            try {
                await fetch("/users/donotsellshare", { method: "POST" });
            } catch {
                // Ignore
            }
        }
    } else {
        try {
            await fetch("/users/donotsellshare?optout=false", { method: "POST" });
        } catch {
            // Ignore
        }
    }
});

// If user previously opted out, re-opt if necessary
// CookieYes has almost no developer-facing documentation, but this undocumented event is fired once it loads the banner DOM
document.addEventListener("cookieyes_banner_load", async () => {
    if (window.UserDoNotSellShare === true) {
        const optOutBox = document.getElementById("ckyCCPAOptOut");
        // Only fire if optout not already checked
        if (optOutBox && !optOutBox.checked) {
            // I'd rather explicitly set checked to true, but CookieYes does extra JS on the click event
            optOutBox.click();
            performBannerAction("reject");
        }
    }
});

// Register required webcomponents
UserAvatar.Register();

WireupMobileMenu();
WireupExpanders();
WireupRevealers();

// Height is capped by the max-height on textarea.auto-resize
autosize(document.querySelectorAll("textarea.auto-resize"));

// Let the document know when the mouse is being used
document.body.addEventListener("mousedown", () => document.body.classList.add("using-mouse"));
document.body.addEventListener("keydown", () => document.body.classList.remove("using-mouse"));

// Detect features we'll need to know about in CSS
if (navigator.share) document.body.classList.add("can-share");
if (/ipad|iphone|ipod/i.test(navigator.userAgent) || ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform)) {
    document.body.classList.add("platform-ios");
}
if (/android/i.test(navigator.userAgent) || navigator.platform === "Android") {
    document.body.classList.add("platform-android");
}

window.addEventListener("avatarUrlChange", e => {
    const menuAvatar = document.getElementById("headerMenuAvatar");
    if (menuAvatar) {
        menuAvatar.avatar = e.detail.content;
    }
});
